import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import MainLayout from '../components/Layout/MainLayout';
import styles from '../assets/styles/ProjectQuota.module.scss';

const REQUEST_KEY_STORAGE = 'project-add-request-key';

const ConfirmAddProject: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const additionalCount = (location.state as { additionalCount?: number } | null)?.additionalCount;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (typeof additionalCount !== 'number') return <Navigate to="/request-add-project" replace />;

  const handleConfirm = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/request-add-project`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          additional_project_count: additionalCount,
          request_key: sessionStorage.getItem(REQUEST_KEY_STORAGE),
        }),
      });
      if (!response.ok) throw new Error('request');
      navigate('/complete-add-project', { state: { additionalCount } });
    } catch (submitError) {
      console.error('Project add request error:', submitError);
      setError('申請に失敗しました。時間をおいて再度お試しください。');
      setIsSubmitting(false);
    }
  };

  return (
    <MainLayout title="プロジェクト追加申請の確認">
      <main className={styles.page}>
        <section className={styles.card}>
          <h1 className={styles.title}>申請内容の確認</h1>
          {error && <p className={styles.error}>{error}</p>}
          <dl className={styles.quotaList}>
            <dt>追加するPJ数</dt><dd>{additionalCount}</dd>
            <dt>月額費用</dt><dd>+{(additionalCount * 100).toLocaleString()}円/月</dd>
          </dl>
          <div className={styles.actions}>
            <button type="button" className={styles.secondaryButton} onClick={() => navigate('/request-add-project')}>戻る</button>
            <button type="button" className={styles.primaryButton} onClick={handleConfirm} disabled={isSubmitting}>
              {isSubmitting ? '処理中...' : '決定'}
            </button>
          </div>
        </section>
      </main>
    </MainLayout>
  );
};

export default ConfirmAddProject;
